<template>
  <Modal
    name="ADVANCE_BALANCE_CONFIRM_MODAL"
    :title="title"
    :width="800"
    actions
    persistent
  >
    <template v-slot:body>
      <v-alert type="warning">
        {{ $t('recharge.hint.advanceBalanceWarning') }}
      </v-alert>

      <v-card class="pa-5" color="grey lighten-4" elevation="0">
        <v-data-table
          :items="[selectedRecharge]"
          :headers="transfersHeader"
          hide-default-footer
          disable-sort
        >
          <template v-slot:[`item.code`]="{ item }">
            <v-chip small>
              <span class="caption">{{ item.code }}</span>
            </v-chip>
          </template>
          <template v-slot:[`item.type`]="{ item }">
            <div class="d-flex" v-if="item.type === 'ASAAS_BOLETO'">
              <v-icon color="grey lighten-2" left>mdi-barcode</v-icon>
              <div class="align-self-center ml-2">
                {{ $t('recharge.billet.title') }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.value`]="{ item }">
            {{ money(item.value) }}
          </template>
        </v-data-table>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isLoadingButton"
        class="mr-5"
        large
        text
      >
        {{ $t('itemPrice.action.cancel') }}
      </v-btn>

      <v-btn
        @click="confirmAdvanceBalance"
        :loading="isLoadingButton"
        color="primary"
        elevation="0"
        large
        dark
      >
        {{ $t('recharge.label.advanceBalance') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { catalogMonetary } from '@/util/catalog'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ModalConfirmAdvanceBalance',

  components: {
    Modal,
  },

  props: {
    selectedRecharge: {
      type: Object,
    }
  },

  computed: {
    ...mapGetters(['isLoadingButton']),
  },

  methods: {
    ...mapActions(['advanceBalance']),
    ...mapMutations(['closeAllModals']),

    confirmAdvanceBalance() {
      this.advanceBalance(this.selectedRecharge.id)
    }
  },

  data() {
    return {
      title: this.$t('recharge.label.confirmAdvanceBalance'),
      money: catalogMonetary,
      transfersHeader: [
        {
          text: this.$t('recharge.label.code'),
          value: 'code',
          align: 'start'
        },
        {
          text: this.$t('recharge.label.type'),
          value: 'type',
        },
        {
          text: this.$t('recharge.label.real_estate'),
          value: 'real_estate.name',
        },
        {
          text: this.$t('recharge.label.amount'),
          value: 'value',
          width: 100,
          align: 'end',
        },
      ]
    }
  },
}
</script>
